/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.4",
    versionName: "0.2.0-nightly.2025.8.4",
    versionChannel: "nightly",
    buildDate: "2025-08-04T00:08:39.652Z",
    commitHash: "5ab392321bbe181d1c2930cd8ec83ca49ebd836d",
};
